import * as DOMElements from './DOMElements';

const isAtTheBottom = (element, tolerance = 20) =>
	element.scrollTop + element.clientHeight >= element.scrollHeight - tolerance;

export const getMessageList = () => document.getElementById('chat');

export const isURL = (str) => {
    var pattern = new RegExp('^((ft|htt)ps?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name and extension
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?'+ // port
        '(\\/[-a-z\\d%@_.~+&:]*)*'+ // path
        '(\\?[;&a-z\\d%@_.,~+&:=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return pattern.test(str);
};

var isNewDateArray = [];

export const createMessage = (id, text, time, authorType, name) => {
	const messageDivContainer = document.createElement('div');
	messageDivContainer.dataset.id = id;
	messageDivContainer.classList.add('message-container', authorType);

	//start date related work
    // console.log(time);
    const timeConvert = new Date(time)
        .toLocaleTimeString({},
            {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'}
        );

    const dateConvert = new Date(time);
    var formattedDate = dateConvert.getDate() + '/' + (dateConvert.getMonth() + 1) + '/' + dateConvert.getFullYear();

    const today = new Date();
    const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    const formattedDateToday = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
    const formattedDateYesterday = yesterday.getDate() + '/' + (yesterday.getMonth() + 1) + '/' + yesterday.getFullYear();

    if(formattedDate === formattedDateToday){
        formattedDate = 'TODAY';
    }
    else if(formattedDate === formattedDateYesterday){
        formattedDate = 'YESTERDAY';
    }

    if (isNewDateArray.indexOf(formattedDate) === -1) {
        isNewDateArray.push(formattedDate);

        const messageDateDiv = document.createElement('div');
        messageDateDiv.innerHTML = '<div class="chatRule"><span class="chatDate">'+formattedDate+'</span></div>';
        messageDivContainer.append(messageDateDiv);
    }
    //end date related work
    text = text.trim();
    if(isURL(text) === true){
        if (text.indexOf('http://') !== 0 && text.indexOf('https://') !== 0){
            const textHttp = 'http://' + text;
            text = '<a href="'+textHttp+'" target="_blank">'+text+'</a>';
        }
        else{
            text = '<a href="'+text+'" target="_blank">'+text+'</a>';
        }
    }

	const messageDiv = document.createElement('div');
	messageDiv.classList.add('message');
	const customerNameClass = (authorType === 'customer') ? 'cName' : '';
	messageDiv.innerHTML = '<div><div class="chatName"><span class="'+customerNameClass+'">' + name + '</span><span class="chatTime">' + timeConvert + '</span></div><div class="chatText">' + text + '</div></div>';
	messageDivContainer.append(messageDiv);
	return messageDivContainer;
};

export const appendMessage = (message) => {
	const messageList = getMessageList();
	const shouldScrollToBottom = isAtTheBottom(messageList);
    // messageList.insertBefore(message, messageList.childNodes[messageList.childNodes.length - 4]);
    messageList.insertBefore(message, messageList.lastChild.previousSibling);
	// messageList.appendChild(message);
	if (shouldScrollToBottom) {
		scrollToBottom();
	}
};

export const prependMessages = (chatId, messages) => {
	const messageList = getMessageList(chatId);
	messages.reverse().forEach((message) => {
		const firstMessage = messageList.children[0];
		if (firstMessage) {
			messageList.insertBefore(message, firstMessage);
			return;
		}
		appendMessage(chatId, message);
	});
};

export const markAsFailedMessage = (id) => {};

export const confirmMessageAsSent = (id) => {};

export const disableInput = (text) => {
	if (text) {
		DOMElements.input.placeholder = text;
	}
	DOMElements.input.disabled = true;
};

export const enableInput = () => {
	DOMElements.input.placeholder = 'Write a message';
	DOMElements.input.disabled = false;
};

export const disableSendButton = () => {
	DOMElements.sendButton.disabled = true;
};

export const enableSendButton = () => {
	DOMElements.sendButton.disabled = false;
};

export const toggleMinimized = () => {
	DOMElements.lcWindow.classList.toggle('minimized');
	DOMElements.lcWindowMinimized.classList.toggle('minimized');
};

export const scrollToBottom = () => {
	const messageList = getMessageList();
	messageList.scrollTop = messageList.scrollHeight;
};

export const showChat = () => {
	DOMElements.startChatButton.style.display = 'none';
	DOMElements.textareaWrapper.style.display = 'flex';

	DOMElements.input.focus();
};

export const hideChat = () => {
	DOMElements.textareaWrapper.style.display = 'none';
	showStartChatButton()
};

export const showFooter = () => {
	DOMElements.footer.style.display = 'block';
};

export const showStartChatButton = () => {
	DOMElements.startChatButton.style.display = 'inline-block';
};

const closest = (to, element) => {
	const toClass = to.substr(1);
	let target = element;
	while (target) {
		if (target.classList.contains(toClass)) {
			return target;
		}
		target = target.parentElement;
	}

	return null;
};

export const delegate = (from, to, eventName, handler) => {
	const targetSelector = `${to}, ${to} *`;

	document.querySelector(from).addEventListener(eventName, (ev) => {
		if (!ev.target.matches(targetSelector)) {
			return;
		}

		handler.call(closest(to, ev.target), ev);
	});
};

// TODO: dedupe it later its a copy from "@livechat/chat.io/utils"
// with exception that this one handles context passing
export const throttle = (ms, fn) => {
	let lastCall = Date.now() - 2 * ms;
	let result;
	let trailing;

	function invoke(...args) {
		lastCall = Date.now();
		return (result = fn.apply(this, args));
	}

	return function throttler(...args) {
		const now = Date.now();

		if (now - lastCall >= ms) {
			return invoke.apply(this, args);
		}

		clearTimeout(trailing);
		trailing = setTimeout(() => invoke.apply(this, args), lastCall - now + ms);

		return result;
	};
};
